import { styled } from 'styled-components';

export const StyledTextarea = styled.textarea`
  width: 100%;
  padding: 10px 14px;
  border: 1.5px solid #E4E7EF;
  border-radius: 10px;
  font-size: 14px;
  color: #1A1D2B;
  background: white;
  transition: all 0.15s ease;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
  resize: vertical;
  min-height: 100px;

  &::placeholder {
    color: #8890A5;
  }

  &:hover {
    border-color: #CDD1DC;
  }

  &:focus {
    outline: none;
    border-color: #008AFF;
    box-shadow: 0 0 0 3px rgba(0, 138, 255, 0.1);
  }

  &:disabled {
    background-color: #F4F5F9;
    cursor: not-allowed;
    opacity: 0.6;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    padding: 12px 14px;
  }
`;
